import { render } from "./MultisendItem.vue?vue&type=template&id=223b9889&scoped=true"
import script from "./MultisendItem.vue?vue&type=script&lang=js"
export * from "./MultisendItem.vue?vue&type=script&lang=js"

import "./MultisendItem.vue?vue&type=style&index=0&id=223b9889&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-223b9889"]])

export default __exports__